/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 바로가기 설치 가이드를 보여주는 탭
 * 버전 : 1.0
 * 파일명 : InstallGuideTap.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-07-10
 * ================================================================ */

import React from 'react'
import { Icon_Upload, Icon_X_Mark } from 'src/components/common/CommonIcons'
import styled from 'styled-components'
import { LoginPageTabType } from './LoginPage'
import Guide_01 from 'src/assets/images/Guide_01.svg'
import Guide_02 from 'src/assets/images/Guide_02.svg'

const PageWrapper = styled.div`
    width: 100%;
    padding: 0px 20px;
    margin-bottom: 36px;
`
const HeaderWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    width: 100%;
    font-size: 18px;
    font-weight: 700;
    padding: 11px;
    margin-bottom: 21px;
`
const RoundBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    border-radius: 100px;
    border: 1px solid #229596;
    background-color: #E9F5F5;
    padding: 8px;
    font-size: 14px;
    color: #229596;
    font-weight: 600;
`
const ContentWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    flex-direction: column;
`
const GrayBox = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;

    width: 100%;
    padding: 10px 20px;
    background-color: #F1F1F1;
    color: #494E58;
    font-size: 14px;
    font-weight: 500;
    gap: 13px;
    line-height: 1.32;
`
interface Props{
    setTab: React.Dispatch<React.SetStateAction<LoginPageTabType>>;
}

const InstallGuideTap = ({setTab}:Props) => {
    return (
        <PageWrapper>
            <HeaderWrapper>
                홈 화면 바로가기 설치 가이드
                <Icon_X_Mark onClick={()=>setTab('Login')} style={{position:'absolute', right:0}}/>
            </HeaderWrapper>
            <ContentWrapper style={{marginBottom:'50px'}}>
                <RoundBox>
                    01. Chrome에서 설치하기
                </RoundBox>
                <img src={Guide_01}/>
                <GrayBox>
                    <span>01. URL 옆 공유하기 버튼 (<Icon_Upload style={{ verticalAlign: 'text-bottom' }}/>) 클릭</span>
                    <span>02. 홈 화면에 추가 클릭</span>
                </GrayBox>
            </ContentWrapper>
            <ContentWrapper>
                <RoundBox>
                    02. Safari에서 설치하기
                </RoundBox>
                <img src={Guide_02}/>
                <GrayBox>
                    <span>01. 하단 공유하기 버튼 (<Icon_Upload style={{ verticalAlign: 'text-bottom' }}/>) 클릭</span>
                    <span>02. 홈 화면에 추가 클릭</span>
                </GrayBox>
            </ContentWrapper>
        </PageWrapper>
    )
}

export default InstallGuideTap